import React from "react";
import heroImg from "../assets/img/hero.svg";
import bgVideo from "../assets/video/web-bg.mp4";

export default function Hero() {
  return (
    <div>
      <section id="hero">
     
      <video autoPlay muted loop>
        <source src={bgVideo} type="video/mp4" />
      </video>
  
        <div className=" container-fluid hero-content ">
          <div className="row d-flex justify-content-center">
            <div className="col-10 col-xl-5 col-md-6 order-md-1 order-2 mt-auto mb-auto">
              <h1>Professional, Quality, Trust</h1>
              <h2>
                Digital experince start with our family and get all Solutions in
                one place.
              </h2>
              <div className="btn-div">
                <a href="#about" className="btn-get-started scrollto">
                  Learn More
                </a>
              </div>
            </div>
            <div className="col-10 col-xl-4 col-md-6 hero-img order-md-2 order-1 mt-5 text-center">
              {/* <img src={heroImg} className="img-fluid animated" alt="" /> */}
            </div>
          </div>
        </div>
      
      </section>
      
    </div>
  );
}
